import filter from "@/api/filter";

var _this;
var _tabsOneActionIndex;
var _tabsTwoActiveIndex;

export function queryColumns(tabsOneActionIndex, tabsTwoActiveIndex, self) {
  _this = self;
  _tabsOneActionIndex = tabsOneActionIndex;
  _tabsTwoActiveIndex = tabsTwoActiveIndex;

  if (_tabsOneActionIndex == 0 && _tabsTwoActiveIndex == 0) {
    _this.searchObj.descs = 't1.chat_date';
    return allAllColumns
  } else if (_tabsOneActionIndex == 0 && _tabsTwoActiveIndex == 1) {
    _this.searchObj.descs = 't2.last_subscribe_date';
    return allAppointmentCustomer
  } else if (_tabsOneActionIndex == 0 && _tabsTwoActiveIndex == 2) {
    _this.searchObj.descs = 't1.chat_date';
    return allOwn
  } else if (_tabsOneActionIndex == 1 && _tabsTwoActiveIndex == 0) {
    _this.searchObj.descs = 't1.chat_date';
    return unsettledAll
  } else if (_tabsOneActionIndex == 1 && _tabsTwoActiveIndex == 1) {
    _this.searchObj.descs = 't2.last_subscribe_date';
    return unsettledAppointmentCustomer
  } else if (_tabsOneActionIndex == 1 && _tabsTwoActiveIndex == 2) {
    _this.searchObj.descs = 't1.chat_date';
    return unsettledOwn
  } else if (_tabsOneActionIndex == 2 && _tabsTwoActiveIndex == 0) {
    _this.searchObj.descs = 't.success_time';
    return closedAll
  } else if (_tabsOneActionIndex == 2 && _tabsTwoActiveIndex == 1) {
    _this.searchObj.descs = 't2.last_subscribe_date';
    return closedAppointmentCustomer
  } else if (_tabsOneActionIndex == 2 && _tabsTwoActiveIndex == 2) {
    _this.searchObj.descs = 't1.chat_date';
    return closedOwn
  }
}

/* 全部 */
// 全部-全部
export const allAllColumns = [
  {
    title: "序号",
    type: 'index',
    align: "center",
    width: 70,
  },
  {
    title: "姓名",
    slot: "name",
    align: "center",
    minWidth: 110
  },
  {
    title: "手机号",
    slot: "mobile1",
    align: "center",
    minWidth: 140
  },
  {
    title: "保单数",
    slot: "successNum",
    align: "center",
    minWidth: 110
  },
  {
    title: "成交保费（元）",
    key: "successFee",
    align: "center",
    minWidth: 130
  },
  {
    title: "客户类型",
    key: 'typeName',
    align: "center",
    minWidth: 110
  },
  {
    title: "客户来源",
    align: "center",
    minWidth: 140,
    render(h, params) {
      const result = params.row.sourceName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: "跟进状态",
    align: "center",
    minWidth: 110,
    render(h, params) {
      const result = params.row.followStatusName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    align: 'center',
    title: "最近沟通时间",
    minWidth: 160,
    render(h, params) {
      const result = params.row.chatTime;
      return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
    }
  },
  {
    title: "操作",
    slot: "bar1",
    align: "center",
    minWidth: 150,
    fixed: "right"
  }
]

// 全部-预约客户
export const allAppointmentCustomer = [
  {
    title: "序号",
    type: 'index',
    align: "center",
    width: 70,
  },
  {
    title: "姓名",
    slot: "name",
    align: "center",
    minWidth: 110
  },
  {
    title: "手机号",
    slot: "mobile1",
    align: "center",
    minWidth: 140
  },
  {
    title: "关注产品",
    width: 350,
    ellipsis: true,
    tooltip: true,
    align: "center",
    key: 'focusProductName',
  },
  {
    title: "客户来源",
    align: "center",
    minWidth: 140,
    render(h, params) {
      const result = params.row.sourceName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: "咨询次数/成交保单数",
    align: "center",
    minWidth: 160,
    slot: "consulSuccessNum"
  },
  {
    title: "成交保费（元）",
    key: "successFee",
    align: "center",
    minWidth: 130
  },
  {
    title: "跟进状态",
    align: "center",
    minWidth: 110,
    render(h, params) {
      const result = params.row.followStatusName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    align: 'center',
    minWidth: 130,
    renderHeader: (h, params) => {
      return h("Dropdown", {
        props: {
          trigger: 'click'
        },
        on: {
          'on-click': () => {
            const dom = document.getElementsByTagName('s');
            const downItemDom = document.getElementsByClassName('ivu-dropdown-item');
            if (dom[0].innerText == '最近预约时间') {
              dom[0].innerText = '最近沟通时间';
              downItemDom[0].innerText = '最近预约时间';
              _this.searchObj.descs = 't1.chat_date';
              _this.getInsureList();
              console.log("最近沟通时间")
            } else {
              dom[0].innerText = '最近预约时间';
              downItemDom[0].innerText = '最近沟通时间';
              _this.searchObj.descs = 't2.last_subscribe_date';
              _this.getInsureList();
              console.log("最近预约时间")
            }
          },
        }
      }, [
        h("a", {
          style: {
            color: '#3C464F'
          },
        }, [
          h("s", '最近预约时间'),
          h("Icon", {
            props: {
              type: "ios-arrow-down"
            },
          })
        ]),
        h("DropdownMenu", {
          slot: "list",
        }, [
          h("DropdownItem", {
            props: {
              name: '最近沟通时间'
            },
            style: {
              fontSize:'12px !important'
            },
          }, "最近沟通时间")
        ])
      ])
    },
    render(h, params) {
      if (_this.searchObj.descs == 't2.last_subscribe_date') {
        const result = params.row.appointmentDate;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      } else if (_this.searchObj.descs == 't1.chat_date') {
        const result = params.row.chatTime;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      }
    }
  },
  {
    title: "操作",
    slot: "bar2",
    align: "center",
    minWidth: 110,
    fixed: "right",
  }
]

// 全部-自有客户
export const allOwn = [
  {
    title: "序号",
    type: 'index',
    align: "center",
    width: 70,
  },
  {
    title: "姓名",
    slot: "name",
    align: "center",
    minWidth: 110
  },
  {
    title: "手机号",
    slot: "mobile1",
    align: "center",
    minWidth: 140
  },
  {
    title: "关注产品",
    width: 350,
    ellipsis: true,
    tooltip: true,
    align: "center",
    key: 'focusProductName',
  },
  {
    title: "客户来源",
    align: "center",
    minWidth: 140,
    render(h, params) {
      const result = params.row.sourceName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: "跟进状态",
    align: "center",
    minWidth: 110,
    render(h, params) {
      const result = params.row.followStatusName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: "保单数",
    slot: "successNum",
    align: "center",
    minWidth: 110
  },
  {
    title: "成交保费（元）",
    key: "successFee",
    align: "center",
    minWidth: 130
  },
  {
    align: 'center',
    minWidth: 130,
    renderHeader: (h, params) => {
      return h("Dropdown", {
        props: {
          trigger: 'click'
        },
        on: {
          'on-click': () => {
            const dom = document.getElementsByTagName('s');
            const downItemDom = document.getElementsByClassName('ivu-dropdown-item');
            if (dom[0].innerText == '最近沟通时间') {
              dom[0].innerText = '创建时间';
              downItemDom[0].innerText = '最近沟通时间';
              _this.searchObj.descs = 't.create_time';
              _this.getInsureList();
              console.log("创建时间")
            } else {
              dom[0].innerText = '最近沟通时间';
              downItemDom[0].innerText = '创建时间';
              _this.searchObj.descs = 't1.chat_date';
              _this.getInsureList();
              console.log("最近沟通时间")
            }
          },
        }
      }, [
        h("a", {
          style: {
            color: '#3C464F'
          },
        }, [
          h("s", '最近沟通时间'),
          h("Icon", {
            props: {
              type: "ios-arrow-down"
            },
          })
        ]),
        h("DropdownMenu", {
          slot: "list",
        }, [
          h("DropdownItem", {
            props: {
              name: '创建时间'
            },
            style: {
              fontSize:'12px !important'
            },
          }, "创建时间")
        ])
      ])
    },
    render(h, params) {
      if (_this.searchObj.descs == 't1.chat_date') {
        const result = params.row.chatTime;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      } else if (_this.searchObj.descs == 't.create_time') {
        const result = params.row.createTime;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      }
    }
  },
  {
    title: "操作",
    slot: "bar3",
    align: "center",
    minWidth: 110,
    fixed: "right",
  }
]

/* 未成交 */
// 未成交-全部
export const unsettledAll = [
  {
    title: "序号",
    type: 'index',
    align: "center",
    width: 70,
  },
  {
    title: "姓名",
    slot: "name",
    align: "center",
    minWidth: 110
  },
  {
    title: "手机号",
    slot: "mobile1",
    align: "center",
    minWidth: 140
  },
  {
    title: "订单数",
    slot: "orderNum",
    minWidth: 110,
    align: "center"
  },
  {
    title: "未成交保费（元）",
    minWidth: 150,
    align: "center",
    render(h, params) {
      return <span>{params.row.orderFee}</span>;
    }
  },
  {
    title: "客户类型",
    key: 'typeName',
    align: "center",
    minWidth: 110
  },
  {
    title: "客户来源",
    align: "center",
    minWidth: 140,
    render(h, params) {
      const result = params.row.sourceName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: "跟进状态",
    align: "center",
    minWidth: 110,
    render(h, params) {
      const result = params.row.followStatusName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: '最近沟通时间',
    align: 'center',
    minWidth: 160,
    render(h, params) {
      const result = params.row.chatTime;
      return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
    }
  },
  {
    title: "操作",
    slot: "bar3",
    align: "center",
    minWidth: 110,
    fixed: "right",
  }
]

// 未成交-预约客户
export const unsettledAppointmentCustomer = [
  {
    title: "序号",
    type: 'index',
    align: "center",
    width: 70,
  },
  {
    title: "姓名",
    slot: "name",
    align: "center",
    minWidth: 110
  },
  {
    title: "手机号",
    slot: "mobile1",
    align: "center",
    minWidth: 140
  },
  {
    title: "关注产品",
    width: 350,
    ellipsis: true,
    tooltip: true,
    align: "center",
    render(h, params) {
      const result = params.row.focusProductName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: "客户来源",
    align: "center",
    minWidth: 140,
    render(h, params) {
      const result = params.row.sourceName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: "咨询次数",
    key: "consulNum",
    minWidth: 110,
    align: "center"
  },
  {
    title: "跟进状态",
    align: "center",
    minWidth: 110,
    render(h, params) {
      const result = params.row.followStatusName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    align: 'center',
    minWidth: 130,
    renderHeader: (h, params) => {
      return h("Dropdown", {
        props: {
          trigger: 'click'
        },
        on: {
          'on-click': () => {
            const dom = document.getElementsByTagName('s');
            const downItemDom = document.getElementsByClassName('ivu-dropdown-item');
            if (dom[0].innerText == '最近预约时间') {
              dom[0].innerText = '最近沟通时间';
              downItemDom[0].innerText = '最近预约时间';
              _this.searchObj.descs = 't1.chat_date';
              _this.getInsureList();
              console.log("最近沟通时间")
            } else {
              dom[0].innerText = '最近预约时间';
              downItemDom[0].innerText = '最近沟通时间';
              _this.searchObj.descs = 't2.last_subscribe_date';
              _this.getInsureList();
              console.log("最近预约时间")
            }
          },
        }
      }, [
        h("a", {
          style: {
            color: '#3C464F'
          },
        }, [
          h("s", '最近预约时间'),
          h("Icon", {
            props: {
              type: "ios-arrow-down"
            },
          })
        ]),
        h("DropdownMenu", {
          slot: "list",
        }, [
          h("DropdownItem", {
            props: {
              name: '最近沟通时间'
            },
            style: {
              fontSize:'12px !important'
            },
          }, "最近沟通时间")
        ])
      ])
    },
    render(h, params) {
      if (_this.searchObj.descs == 't2.last_subscribe_date') {
        const result = params.row.appointmentDate;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      } else if (_this.searchObj.descs == 't1.chat_date') {
        const result = params.row.chatTime;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      }
    }
  }
]

// 未成交-自有客户
export const unsettledOwn = [
  {
    title: "序号",
    type: 'index',
    align: "center",
    width: 70,
  },
  {
    title: "姓名",
    slot: "name",
    align: "center",
    minWidth: 110
  },
  {
    title: "手机号",
    slot: "mobile1",
    align: "center",
    minWidth: 140
  },
  {
    title: "关注产品",
    width: 350,
    ellipsis: true,
    tooltip: true,
    align: "center",
    render(h, params) {
      const result = params.row.focusProductName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: "客户来源",
    align: "center",
    minWidth: 140,
    render(h, params) {
      const result = params.row.sourceName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: "订单数",
    slot: "orderNum",
    minWidth: 110,
    align: "center"
  },
  {
    title: "跟进状态",
    align: "center",
    minWidth: 110,
    render(h, params) {
      const result = params.row.followStatusName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    align: 'center',
    minWidth: 130,
    renderHeader: (h, params) => {
      return h("Dropdown", {
        props: {
          trigger: 'click'
        },
        on: {
          'on-click': () => {
            const dom = document.getElementsByTagName('s');
            const downItemDom = document.getElementsByClassName('ivu-dropdown-item');
            if (dom[0].innerText == '最近沟通时间') {
              dom[0].innerText = '创建时间';
              downItemDom[0].innerText = '最近沟通时间';
              _this.searchObj.descs = 't.create_time';
              _this.getInsureList();
              console.log("创建时间")
            } else {
              dom[0].innerText = '最近沟通时间';
              downItemDom[0].innerText = '创建时间';
              _this.searchObj.descs = 't1.chat_date';
              _this.getInsureList();
              console.log("最近沟通时间")
            }
          },
        }
      }, [
        h("a", {
          style: {
            color: '#3C464F'
          },
        }, [
          h("s", '最近沟通时间'),
          h("Icon", {
            props: {
              type: "ios-arrow-down"
            },
          })
        ]),
        h("DropdownMenu", {
          slot: "list",
        }, [
          h("DropdownItem", {
            props: {
              name: '创建时间'
            },
            style: {
              fontSize:'12px !important'
            },
          }, "创建时间")
        ])
      ])
    },
    render(h, params) {
      if (_this.searchObj.descs == 't1.chat_date') {
        const result = params.row.chatTime;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      } else if (_this.searchObj.descs == 't.create_time') {
        const result = params.row.createTime;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      }
    }
  },
  {
    title: "操作",
    slot: "bar3",
    align: "center",
    minWidth: 110,
    fixed: "right",
  }
]

/* 已成交 */
// 已成交-全部
export const closedAll = [
  {
    title: "序号",
    type: 'index',
    align: "center",
    width: 70,
  },
  {
    title: "姓名",
    slot: "name",
    align: "center",
    minWidth: 110
  },
  {
    title: "手机号",
    slot: "mobile1",
    align: "center",
    minWidth: 140
  },
  {
    title: "保单数",
    slot: "successNum",
    align: "center",
    minWidth: 110
  },
  {
    title: "成交保费（元）",
    minWidth: 130,
    key: "successFee",
    align: "center",

  },
  {
    title: "退保保费（元）",
    minWidth: 130,
    key: "surrenderFee",
    align: "center"
  },
  {
    title: "客户类型",
    key: 'typeName',
    align: "center",
    minWidth: 110
  },
  {
    title: "客户来源",
    align: "center",
    minWidth: 140,
    render(h, params) {
      const result = params.row.sourceName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: "跟进状态",
    align: "center",
    minWidth: 110,
    render(h, params) {
      const result = params.row.followStatusName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    align: 'center',
    minWidth: 130,
    renderHeader: (h, params) => {
      return h("Dropdown", {
        props: {
          trigger: 'click'
        },
        on: {
          'on-click': () => {
            const dom = document.getElementsByTagName('s');
            const downItemDom = document.getElementsByClassName('ivu-dropdown-item');
            if (dom[0].innerText == '最近沟通时间') {
              dom[0].innerText = '最近成交时间';
              downItemDom[0].innerText = '最近沟通时间';
              _this.searchObj.descs = 't.success_time';
              _this.getInsureList();
              console.log("最近成交时间")
            } else {
              dom[0].innerText = '最近沟通时间';
              downItemDom[0].innerText = '最近成交时间';
              _this.searchObj.descs = 't1.chat_date';
              _this.getInsureList();
              console.log("最近沟通时间")
            }
          },
        }
      }, [
        h("a", {
          style: {
            color: '#3C464F'
          },
        }, [
          h("s", '最近成交时间'),
          h("Icon", {
            props: {
              type: "ios-arrow-down"
            },
          })
        ]),
        h("DropdownMenu", {
          slot: "list",
        }, [
          h("DropdownItem", {
            props: {
              name: '最近沟通时间'
            },
            style: {
              fontSize:'12px !important'
            },
          }, "最近沟通时间")
        ])
      ])
    },
    render(h, params) {
      if (_this.searchObj.descs == 't.success_time') {
        const result = params.row.successTime;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      } else if (_this.searchObj.descs == 't1.chat_date') {
        const result = params.row.chatTime;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      }
    }
  }
]

// 已成交-预约客户
export const closedAppointmentCustomer = [
  {
    title: "序号",
    type: 'index',
    align: "center",
    width: 70,
  },
  {
    title: "姓名",
    slot: "name",
    align: "center",
    minWidth: 110
  },
  {
    title: "手机号",
    slot: "mobile1",
    minWidth: 140,
    align: "center"
  },
  {
    title: "咨询次数/成交保单数",
    minWidth: 160,
    align: "center",
    slot: "consulSuccessNum"
  },
  {
    title: "成交保费（元）",
    minWidth: 130,
    key: "successFee",
    align: "center"
  },
  {
    title: "退保保费（元）",
    minWidth: 130,
    key: "surrenderFee",
    align: "center"
  },
  {
    title: "客户来源",
    align: "center",
    minWidth: 140,
    render(h, params) {
      const result = params.row.sourceName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: "跟进状态",
    align: "center",
    minWidth: 110,
    render(h, params) {
      const result = params.row.followStatusName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    align: 'center',
    minWidth: 130,
    renderHeader: (h, params) => {
      return h("Dropdown", {
        props: {
          trigger: 'click'
        },
        on: {
          'on-click': () => {
            const dom = document.getElementsByTagName('s');
            const downItemDom = document.getElementsByClassName('ivu-dropdown-item');
            if (dom[0].innerText == '最近沟通时间') {
              dom[0].innerText = '最近预约时间';
              downItemDom[0].innerText = '最近沟通时间';
              _this.searchObj.descs = 't2.last_subscribe_date';
              _this.getInsureList();
              console.log("最近预约时间")
            } else {
              dom[0].innerText = '最近沟通时间';
              downItemDom[0].innerText = '最近预约时间';
              _this.searchObj.descs = 't1.chat_date';
              _this.getInsureList();
              console.log("最近沟通时间")
            }
          },
        }
      }, [
        h("a", {
          style: {
            color: '#3C464F'
          },
        }, [
          h("s", '最近预约时间'),
          h("Icon", {
            props: {
              type: "ios-arrow-down"
            },
          })
        ]),
        h("DropdownMenu", {
          slot: "list",
        }, [
          h("DropdownItem", {
            props: {
              name: '最近沟通时间'
            },
            style: {
              fontSize:'12px !important'
            },
          }, "最近沟通时间")
        ])
      ])
    },
    render(h, params) {
      if (_this.searchObj.descs == 't2.last_subscribe_date') {
        const result = params.row.appointmentDate;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      } else if (_this.searchObj.descs == 't1.chat_date') {
        const result = params.row.chatTime;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      }
    }
  }
]

// 已成交-自有客户
export const closedOwn = [
  {
    title: "序号",
    type: 'index',
    align: "center",
    width: 70,
  },
  {
    title: "姓名",
    slot: "name",
    align: "center",
    minWidth: 110
  },
  {
    title: "手机号",
    slot: "mobile1",
    minWidth: 140,
    align: "center"
  },
  {
    title: "保单数",
    slot: "successNum",
    align: "center",
    minWidth: 110
  },
  {
    title: "成交保费（元）",
    key: "successFee",
    align: "center",
    minWidth: 130
  },
  {
    title: "退保保费（元）",
    key: "surrenderFee",
    align: "center",
    minWidth: 130
  },
  {
    title: "客户来源",
    align: "center",
    minWidth: 140,
    render(h, params) {
      const result = params.row.sourceName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    title: "跟进状态",
    align: "center",
    minWidth: 110,
    render(h, params) {
      const result = params.row.followStatusName;
      return <span>{result || '-'}</span>;
    }
  },
  {
    align: 'center',
    minWidth: 130,
    renderHeader: (h, params) => {
      return h("Dropdown", {
        props: {
          trigger: 'click'
        },
        on: {
          'on-click': () => {
            const dom = document.getElementsByTagName('s');
            const downItemDom = document.getElementsByClassName('ivu-dropdown-item');
            if (dom[0].innerText == '最近沟通时间') {
              dom[0].innerText = '创建时间';
              downItemDom[0].innerText = '最近沟通时间';
              _this.searchObj.descs = 't.create_time';
              _this.getInsureList();
              console.log("创建时间")
            } else {
              dom[0].innerText = '最近沟通时间';
              downItemDom[0].innerText = '创建时间';
              _this.searchObj.descs = 't1.chat_date';
              _this.getInsureList();
              console.log("最近沟通时间")
            }
          },
        }
      }, [
        h("a", {
          style: {
            color: '#3C464F'
          },
        }, [
          h("s", '最近沟通时间'),
          h("Icon", {
            props: {
              type: "ios-arrow-down"
            },
          })
        ]),
        h("DropdownMenu", {
          slot: "list",
        }, [
          h("DropdownItem", {
            props: {
              name: '创建时间'
            },
            style: {
              fontSize:'12px !important'
            },
          }, "创建时间")
        ])
      ])
    },
    render(h, params) {
      if (_this.searchObj.descs == 't1.chat_date') {
        const result = params.row.chatTime;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      } else if (_this.searchObj.descs == 't.create_time') {
        const result = params.row.createTime;
        return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
      }
    }
  }
]